import React from "react";
import { Box, Stack, Typography, Divider } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { ColorsConstants, grayFontColor } from "../../../../cssUtils/constants";
import typography from "../../../../cssUtils/typography";
import { StringField } from "../ConfigFields/StringField";

const DEFAULT_BUTTON_LABEL = "Pay Now";

const PaymentLinkMessagePreview = ({ messageText, buttonLabel, onButtonLabelChange }) => {
  const previewBody = messageText || "*Payment Link:*";
  const previewButtonLabel = buttonLabel || DEFAULT_BUTTON_LABEL;

  return (
    <Stack spacing={2}>
      <StringField
        fieldKey="stripe_button_label"
        schema={{ description: 'e.g. "Complete Payment", "Pay ₹500"' }}
        value={buttonLabel}
        required={false}
        onChange={onButtonLabelChange}
      />

      <Box>
        <Typography
          sx={{
            ...typography.bodySmall,
            fontWeight: 600,
            textTransform: "uppercase",
            color: grayFontColor,
            mb: 1,
          }}
        >
          Preview
        </Typography>

        <Box sx={{ backgroundColor: "#E5DDD5", borderRadius: 2, p: 2 }}>
          <Box
            sx={{
              maxWidth: 280,
              backgroundColor: "#fff",
              borderRadius: 1.5,
              boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                whiteSpace: "pre-wrap",
                p: 1.5,
              }}
            >
              {previewBody}
            </Typography>

            <Divider />

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              gap={0.5}
              sx={{ py: 1.2, color: ColorsConstants.secondaryBackgroundColor }}
            >
              <OpenInNew sx={{ fontSize: 16 }} />
              <Typography sx={{ ...typography.bodyLarge, fontWeight: 600 }}>
                {previewButtonLabel}
              </Typography>
            </Stack>
          </Box>
        </Box>

        <Typography sx={{ ...typography.bodySmall, color: grayFontColor, mt: 1 }}>
          Sent as an interactive CTA-URL message. If that message type can't be
          delivered (e.g. an unapproved template or an unsupported client), it
          automatically falls back to a plain-text message with the link
          appended.
        </Typography>
      </Box>
    </Stack>
  );
};

export default PaymentLinkMessagePreview;
